import ManufacturerContainer from "./ManufacturerContainer";
import ManufacturerStore from "./ManufacturerStore";
export default ManufacturerStore(ManufacturerContainer);